import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=54d40af5&"
import script from "./ColorSelector.vue?vue&type=script&lang=js&"
export * from "./ColorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports